import React from 'react';
import styled from 'styled-components';

import Box from '../Box';

const SPACER_VARIANT = {
  NAVBAR: 'NAVBAR',
};

const getPadding = (variant) => {
  switch (variant) {
    case SPACER_VARIANT.NAVBAR:
      return '32.5px 0';
    default:
      return '0';
  }
};
const Spacer = styled(({ variant, ...restProps }) => <Box {...restProps} />)`
  padding: ${(props) => props.variant && getPadding(props.variant)};
`;

export { SPACER_VARIANT };
export default Spacer;
